import { useMemo, createElement, useContext, createContext } from 'react';
import { ToastProvider } from '../Toast/Toaster.js';

const defaultLocalisationTexts = {
  calendar: {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    actions: {
      previousMonth: 'Previous month',
      nextMonth: 'Next month',
      previousYear: 'Previous year',
      nextYear: 'Next year',
      today: 'Today'
    }
  },
  combobox: {
    tooltip: 'Search in list'
  },
  datepicker: {
    calendar: 'Calendar',
    clear: 'Clear',
    expand: 'Show calendar',
    shortcuts: 'Shortcuts'
  },
  hanger: {
    close: 'Close'
  },
  listbox: {
    loading: 'Loading results...',
    empty: 'No results found',
    allOption: 'All'
  },
  dialog: {
    close: 'Close',
    drag: 'Drag'
  },
  pagination: {
    label: 'Pagination',
    pageSize: 'Items per page',
    showingXofYofTotal: 'Showing [X] - [Y] of [total]',
    actions: {
      firstPage: 'Goto first page',
      firstPageWithShortcut: 'Goto first page (Home)',
      previousPage: 'Goto previous page',
      previousPageWithShortcut: 'Goto previous page (Page Up)',
      nextPage: 'Goto next page',
      nextPageWithShortcut: 'Goto next page (Page Down)',
      lastPage: 'Goto last page',
      lastPageWithShortcut: 'Goto last page (End)',
      pageX: 'Goto page [X]'
    }
  },
  table: {
    actions: 'Other actions',
    edit: 'Edit (e)',
    copy: 'Copy (c)',
    del: 'Delete (del)',
    newSubRow: 'New row (shift + n)',
    loading: 'Loading...'
  },
  select: {
    allOptionsSelected: 'All'
  },
  toasts: {
    dismiss: 'Dismiss'
  },
  tour: {
    back: 'Back',
    close: 'Close',
    skip: 'Close and complete',
    last: 'Done',
    next: 'Next',
    open: 'Open'
  },
  searchInput: {
    inputLabel: 'Search...'
  }
};
const defaultLocalizationContext = {
  locale: 'en-GB',
  texts: defaultLocalisationTexts,
  formatting: {
    date: 'dd.mm.yy'
  }
};
const Context = /*#__PURE__*/createContext({
  localization: defaultLocalizationContext
});
const Provider = props => {
  const {
    children,
    localization = defaultLocalizationContext
  } = props;
  const value = useMemo(() => ({
    localization
  }), [localization]);
  return createElement(Context.Provider, {
    value: value
  }, createElement(ToastProvider, null, children));
};
const useTaco = () => useContext(Context);
const useLocalization = () => useTaco().localization;

export { Provider, defaultLocalisationTexts, useLocalization, useTaco };
//# sourceMappingURL=Provider.js.map
